import { useMemo } from 'react';
// routes
import { paths } from 'src/routes/paths';
// components
import Iconify from 'src/components/iconify';
import SvgColor from 'src/components/svg-color';
// utils
import { crm_keys } from 'src/utils/crm-commons';

// ----------------------------------------------------------------------

const icon = (name) => (
  <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
);

const icon_iconify = (name, size = 24) => (
  <Iconify icon={name} sx={{ fontSize: 24, width: 40 }} />
);

const ICONS = {
  blog: icon('ic_blog'),
  crm: icon('ic_user'),
  landing: icon('ic_landing'),
  external: icon('ic_external'),
  dashboard: icon('ic_dashboard'),
  editor: icon_iconify('solar:clapperboard-edit-bold'),
  billing: icon_iconify('solar:bill-check-bold'),
  reviews: icon_iconify('solar:star-circle-bold-duotone'),
  label: icon('ic_label'),
  kanban: icon('ic_kanban'),
  setup: icon('ic_setup'),
  users: icon('ic_users'),
  call: icon_iconify('solar:volume-bold-duotone'),
};

// ----------------------------------------------------------------------

export function useNavData() {
  const data = useMemo(
    () => [
      // Dashboard
      // ----------------------------------------------------------------------
      {
        subheader: 'Dashboard',
        items: [
          { title: 'Home', path: paths.dashboard.root, icon: ICONS.dashboard },
          {
            title: 'CRM',
            path: paths.dashboard.crm.root('contacts'),
            icon: ICONS.crm,
            children: [
              {
                title: 'Records',
                path: paths.dashboard.crm.root('contacts'),
                children: crm_keys.map((crm) => ({
                  title: crm.plural,
                  path: paths.dashboard.crm.root(crm.pluralLowerCase),
                })),
              },
              { title: 'Activities', path: paths.dashboard.crm.activities },
              {
                title: 'Setup',
                path: paths.dashboard.crm.settings.root,
                children: [
                  { title: 'System Fields', path: paths.dashboard.crm.settings.root },
                  { title: 'Pipelines', path: paths.dashboard.crm.pipelines.root },
                  {
                    title: 'Layouts',
                    path: paths.dashboard.crm.layouts.root('contacts'),
                    children: crm_keys.map((crm) => ({
                      title: crm.plural,
                      path: paths.dashboard.crm.layouts.root(crm.pluralLowerCase),
                    })),
                  },
                  { title: 'Data Import', path: paths.dashboard.crm.data_import.root },
                ],
              },
            ],
          },
          {
            title: 'users',
            path: paths.dashboard.users.root,
            icon: ICONS.users,
            children: [
              { title: 'List', path: paths.dashboard.users.root },
              { title: 'Create', path: paths.dashboard.users.new },
              { title: 'Teams', path: paths.dashboard.users.teams.root },
              { title: 'Permission Sets', path: paths.dashboard.users.permissions.root },
            ],
          },
        ],
      },
      // WEBFINDER
      // ----------------------------------------------------------------------
      {
        subheader: 'WEBFINDER',
        items: [
          {
            title: 'webfinder',
            path: paths.dashboard.websites.root,
            icon: ICONS.external,
            children: [
              { title: 'Websites', path: paths.dashboard.websites.root },
              { title: 'Landing Pages', path: paths.dashboard.landing_pages.root },
              { title: 'Blogs', path: paths.dashboard.blogs.root },
              { title: 'Reviews', path: paths.dashboard.reviews.root },
              // { title: 'Gallery', path: paths.dashboard.gallery.root },
            ],
          },
        ],
      },
    ],
    []
  );

  return data;
}
